import { useTranslation } from 'react-i18next'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import { mentionsOptions } from './constants'
import * as Styles from './styles'

const MentionsConfiguration = ({ onChangeMentionNotifications, mentionsNotificationsValue }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleM">{t('Menciones')}</Text>
      <Text type="bodyMRegular">
        {t('Elige dónde quieres recibir las notificaciones cuando te mencionen en comentarios.')}
      </Text>
      <ComboBox
        fullWidth
        label={t('Notificación de menciones')}
        menuItems={mentionsOptions.map(o => ({ ...o, label: t(o.label) }))}
        handleChange={e => onChangeMentionNotifications(e.target.value)}
        value={mentionsNotificationsValue}
      />
    </Styles.Container>
  )
}

export default MentionsConfiguration
